<div class="relative inline-block">

  <button
    type="button"
    (click)="toggle($event)"
    [attr.aria-expanded]="open"
    aria-haspopup="listbox"
    class="inline-flex items-center px-3 py-1.5 text-sm font-medium text-secondary dark:text-white bg-gray-50 dark:bg-primary-200 rounded-lg hover:opacity-90 transition-colors duration-150"
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-4 w-4 mr-1.5">
      <path fill-rule="evenodd" d="M2.5 4.75A.75.75 0 0 1 3.25 4h13.5a.75.75 0 0 1 0 1.5H3.25a.75.75 0 0 1-.75-.75Zm2 5A.75.75 0 0 1 5.25 9h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75Zm2 5a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Z" clip-rule="evenodd" />
    </svg>
    <span class="hidden sm:inline mr-1 opacity-70">Sort:</span>
    <span>{{ currentLabel }}</span>
    <svg class="ml-1 -mr-0.5 h-4 w-4 opacity-70 transition-transform" [class.rotate-180]="open" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.168l3.71-3.938a.75.75 0 1 1 1.08 1.04l-4.25 4.5a.75.75 0 0 1-1.08 0l-4.25-4.5a.75.75 0 0 1 .02-1.06Z" clip-rule="evenodd" />
    </svg>
  </button>

  <ul
    *ngIf="open"
    role="listbox"
    class="absolute right-0 z-50 mt-2 w-full max-h-[216px] origin-top-right overflow-y-auto overflow-x-hidden rounded-lg bg-white dark:bg-secondary-700 shadow-2xl focus:outline-none custom-scroll"
  >
    <li *ngFor="let choice of choices"
        role="option"
        [attr.aria-selected]="isActive(choice)"
        (click)="select(choice)"
        [ngClass]="isActive(choice)
          ? 'bg-primary text-white font-medium'
          : 'text-gray-700 dark:text-primary-200 hover:bg-gray-50 dark:hover:bg-secondary-900'"
        class="flex items-center justify-between gap-2 px-4 py-2 text-sm cursor-pointer transition-colors">
      <span>{{ choice.label }}</span>
      <svg *ngIf="isActive(choice)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-4 w-4">
        <path fill-rule="evenodd" d="M16.704 5.29a1 1 0 0 1 .006 1.414l-7.5 7.55a1 1 0 0 1-1.42 0l-3.5-3.525a1 1 0 1 1 1.42-1.408l2.79 2.81 6.79-6.834a1 1 0 0 1 1.414-.007Z" clip-rule="evenodd" />
      </svg>
    </li>
  </ul>

</div>
